// extracted by mini-css-extract-plugin
export default {"card":"ActivityCard_card__hhFeb","cardIn":"ActivityCard_cardIn__df0g8","time":"ActivityCard_time__ov2An","title":"ActivityCard_title__jsNhP","compact":"ActivityCard_compact__0P3PF"};